import React from 'react';
import KidBackground from './KidBackground';
import splashImage from '../../assets/splash.png';

/** Premium page shell gradient — matches Gallery Studio / museum pages */
export const atmospherePremiumPageStyle = {
  background:
    'radial-gradient(circle at 0% 0%, rgba(255, 221, 132, 0.22), transparent 35%), radial-gradient(circle at 100% 100%, rgba(255, 183, 77, 0.16), transparent 40%), linear-gradient(180deg, #FFFDF7 0%, #FFF7E8 100%)',
};

/**
 * Decorative background layers for full-page Artmosphere experiences.
 * Place inside a `relative overflow-hidden` container; content should use `relative z-10`.
 */
export default function ArtmospherePremiumBackground({
  variant = 'aurora',
  intensity = 0.38,
  className = '',
}) {
  return (
    <div className={`pointer-events-none absolute inset-0 ${className}`.trim()} aria-hidden>
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -left-[8%] top-0 h-[42%] w-[55%] rounded-b-[50%] border border-[#F5D99B]/40 bg-gradient-to-b from-white/50 to-transparent opacity-80" />
        <div className="absolute left-1/2 top-[6%] h-24 w-40 -translate-x-1/2 rounded-t-full border border-[#E8C97A]/50 bg-gradient-to-b from-[#FFF9EF]/90 to-transparent shadow-[0_12px_40px_rgba(120,72,20,0.06)]" />
        <div className="pointer-events-none absolute right-[6%] top-[18%] h-28 w-36 rotate-3 rounded-lg border-2 border-[#F5D99B]/60 bg-gradient-to-br from-white/40 to-amber-50/20 shadow-inner" />
      </div>
      <div className="absolute inset-0 z-[1] overflow-hidden opacity-[0.07]">
        <img
          src={splashImage}
          alt=""
          className="absolute -right-8 top-24 max-w-[min(420px,45vw)] rotate-12"
          style={{ mixBlendMode: 'multiply', filter: 'blur(1px)' }}
        />
      </div>
      <KidBackground variant={variant} intensity={intensity} className="z-0" />
    </div>
  );
}
